/**
 * Due to the transition to Figma and Styled Components, a lot of
 * Typography variants have been removed or renamed.
 *
 * This list of tuples acts as a temporary list to map an old
 * variant to a supported variant. When an alias is used, it will
 * log a warning to the console too.
 */
export const deprecatedAliasList = [
    ['button-link-text', 'button-link'],
    ['button-text', 'button-link'],
    ['component-action-label-title', 'price-text-sm'],
    ['component-content-title', 'content-title'],
    ['component-counter-text', 'counter-number'],
    ['component-error-messages-text', 'field-validation'],
    ['component-label-title', 'label-title'],
    ['component-number', 'sticker-text-md'],
    ['component-status-text', 'support-text'],
    ['component-support-text', 'support-text'],
    ['component-tag-label-text', 'label-title'],
    ['component-tooltip-text', 'tooltip-text'],
    ['component-tooltip-title', 'tooltip-title'],
    ['content-action-subtitle', 'content-subtitle'],
    ['content-disclaimer-text', 'support-text'],
    ['content-intro-subtitle', 'content-subtitle'],
    ['date-content-text', 'content-subtitle'],
    ['list-label-body-text', 'body-text'],
    ['receipt-body-text', 'support-text'],
    ['sticker-text-large', 'sticker-text-lg'],
    ['sticker-text-medium', 'sticker-text-md'],
    ['sticker-text-small', 'sticker-text-sm'],
    ['sub-link-text', 'footer-link'],
];
